// Login to purchase
document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
    const loginLink = event.target.closest('.js-login-link');

    if (!loginLink) return;

    sessionStorage.setItem('returnUrl', window.location.href);
    });

    const returnUrl = sessionStorage.getItem('returnUrl');

    if (!returnUrl) return;

    const customerLoggedIn =
        document.documentElement.dataset.customerLoggedIn === 'true';

    if (customerLoggedIn) {
        sessionStorage.removeItem('returnUrl');

        if (window.location.href !== returnUrl) {
        window.location.href = returnUrl;
        }
    }
});